// Module
var code = ` <fdx-root></fdx-root> <div id="main-content-container" ng-class="{'fit-iframe': fitIframe}" ui-view></div> <div block-ui="main" class="block-ui-main"></div> <div class="fdx-toast" ng-class="{'fdx-lower-toast':lowerToast()}"> <toast></toast> </div> <fdx-bs3-container></fdx-bs3-container> `;
// Exports
module.exports = code;